import { useState } from 'react';
import TextField, { type TextFieldProps } from '@mui/material/TextField';
import { pricingInputDisplay, pricingInputValue } from '../../shared/pricingDisplay';

type Props = Omit<TextFieldProps, 'value' | 'onChange'> & {
  value: unknown;
  allowEmpty?: boolean;
  adjustment?: boolean;
  onChange: (event: { target: { value: string } }) => void;
};

/** Editors show net markup; callers continue storing the unchanged gross percentage. */
export default function MarginField({ value, onChange, allowEmpty = false, adjustment = false, helperText, sx, ...props }: Props) {
  const [draft, setDraft] = useState<string | null>(null);
  return <TextField
    {...props}
    type="number"
    value={draft ?? pricingInputDisplay(value, adjustment)}
    onFocus={() => setDraft(pricingInputDisplay(value, adjustment))}
    onBlur={() => setDraft(null)}
    onChange={event => {
      const input = event.target.value;
      setDraft(input);
      if ((!allowEmpty && input === '') || (input !== '' && !Number.isFinite(Number(input)))) return;
      const total = pricingInputValue(input, value, adjustment);
      onChange({ target: { value: total === null ? '' : String(total) } });
    }}
    inputProps={{ ...props.inputProps, step: 'any', 'aria-label': props.label ? undefined : (adjustment ? 'Korekcija cijene (%)' : 'Marža bez PDV-a (%)') }}
    helperText={helperText || (adjustment ? '0% = izvorna cijena' : '+ 17% PDV')}
    sx={[{ minWidth: 115 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
  />;
}
